export default __webpack_public_path__ + "static/SR China - Safety Data Sheet Caramel Color (Liquid)-f022d3aecbd2253ea0260f3c83250a33.pdf";